import React from 'react'
import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone , faXmark } from '@fortawesome/free-solid-svg-icons';
import './ModalPopUp.css'

export const ModalPopUp = ({showModalPopUp,handleCloseModalPopUp}) => {
    const [imageLoading, setImageLoading] = useState(true);

    const windowWidth = window.innerWidth;

    const Llamar = () => {
        window.location.href = 'tel:6003001515';
    }

    const Correo = () => {
        window.location.href = 'mailto: importaciones@liche.cl';
    }
  return (
    <Modal show={showModalPopUp} onHide={handleCloseModalPopUp} size='lg' centered  style={{ width: '100%' }}> 
        <Modal.Body>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
        <FontAwesomeIcon icon={faXmark} size='xl' onClick={handleCloseModalPopUp} className='icon-stock'/>
            </div>
            <div className='row borde-modal'>
                <div className='col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 text-center'>
                        {/*Aqui va una imagen centrada */}
                        {imageLoading && <p>Cargando...</p>}
                        <img onLoad={() => setImageLoading(false)} src='/contacto.png' alt='imagen contacto' className='img-fluid' style={{ maxWidth: '290px' ,width: '100%', height: 'auto' }}/>
                        
                </div>
                <div className='col-12 col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 d-flex align-items-center'>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 pe-5'>
                    <h3>Contáctanos</h3>
                    </div>
                    <div className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 ${windowWidth > 576 ? 'pe-5' : null}`}>
                     <p>Contamos con stock de SYNACTHEN DEPOT, para adquirirlo comunícate con nosotros.</p>
                    </div>
                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
                    <button className={`popUp-boton ${windowWidth < 576 ? 'ancho-boton': null}`} onClick={Llamar}>  
                    <FontAwesomeIcon icon={faPhone} className='pe-2'/>
                        6003001515  
                    </button>
                    <button className={`popUp-correo ${windowWidth < 576 ? 'ancho-boton': null}`} onClick={Correo}>  
                    <FontAwesomeIcon icon={faEnvelope} className='pe-2'/>
                        Correo  
                    </button>
                    </div>
                    </div>
                </div>
            </div>
        </Modal.Body>
    </Modal>
  )
}
